<div>
    <select class="form-select me-3"
    name="language" title="language" required [(ngModel)]="languageSelected" (change)="onLanguageChange($event)" [disabled]="btnDesable">
        <option *ngFor="let lang of langList" [value]="lang.id">{{lang.label | propValue}}</option>
    </select>
</div>
